import { CustomerCustomFieldType } from "../customer/types/CustomerCustomFieldType";

export const fieldTypes: CustomerCustomFieldType[] = [
  "text",
  "mobile",
  "url",
  "email",
  "dropdown",
] as const;

export const enabledFieldTypes = fieldTypes;

export type FieldTypes = (typeof fieldTypes)[number];

export type FormField = {
  created_by: string | null;
  entity_id: string;
  id: string;
  name: string;
  pos: number;
  required: boolean;
  section: "company" | "personal";
  type: FieldTypes;
  is_cust_field: boolean;
  read_only: boolean;
  value: string | null | undefined;
  visibility: boolean;
  values?:
    | {
        id: string;
        value: string;
        color: string;
        order: number;
      }[]
    | null;
};
